export type RegistrationReceiptData = {
  numero_inscricao: string;
  nome: string;
  cpf: string;
  email?: string;
  created_at?: string; // ISO string
  status?: string;
};

export function openRegistrationReceipt(data: RegistrationReceiptData) {
  const { numero_inscricao, nome, cpf, email, created_at, status } = data;

  const createdAtDisplay = created_at
    ? new Date(created_at).toLocaleString()
    : new Date().toLocaleString();

  const statusDisplay = status ? status : 'Recebida';

  // Abre em nova ABA (sem features de pop-up)
  const win = window.open('', '_blank');
  if (!win) {
    alert('Não foi possível abrir a nova aba. Verifique o bloqueador de pop-up.');
    return;
  }
  win.opener = null;

  const html = `
    <!doctype html>
    <html lang="pt-BR">
      <head>
        <meta charset="utf-8">
        <title>Comprovante de Inscrição — MCMV</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <style>
          /* estilos simplificados para impressão */
          :root { --primary:#222; --accent:#0A7AFF; --muted:#666; --border:#e5e7eb; }
          * { box-sizing: border-box; }
          body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; color: var(--primary); margin: 0; padding: 24px; background: #fff; }
          .wrapper { max-width: 820px; margin: 0 auto; border: 1px solid var(--border); border-radius: 12px; padding: 24px; }
          .header { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 16px; }
          .brand { display: flex; flex-direction: column; gap: 4px; }
          .brand h1 { font-size: 20px; margin: 0; }
          .brand p { margin: 0; color: var(--muted); font-size: 13px; }
          .title { margin: 8px 0 24px; padding-bottom: 12px; border-bottom: 1px solid var(--border); }
          .title h2 { margin: 0; font-size: 18px; }
          .badge { display: inline-block; padding: 6px 10px; border-radius: 6px; background: #f5f7ff; color: var(--accent); font-weight: 600; letter-spacing: 0.3px; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace; }
          .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
          .row { display: flex; gap: 8px; }
          .label { color: var(--muted); min-width: 140px; }
          .value { font-weight: 600; }
          .footer { margin-top: 24px; padding-top: 12px; border-top: 1px solid var(--border); display: flex; justify-content: space-between; align-items: center; }
          .print-actions { display: flex; gap: 8px; }
          .btn { appearance: none; border: 1px solid var(--border); background: #fff; color: var(--primary); padding: 8px 12px; border-radius: 8px; cursor: pointer; font-weight: 600; }
          .btn-primary { background: var(--accent); border-color: var(--accent); color: #fff; }
          /* Logos do cabeçalho */
          .landing-header { width: 100%; }
          .header-logos-grid { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 8px; }
          .logo-cell { flex: 1; display: flex; align-items: center; justify-content: center; }
          .header-logo { max-height: 48px; width: auto; object-fit: contain; }
          @media print { .btn { display: none; } .wrapper { border: none; padding: 0; } body { padding: 0; } }
        </style>
      </head>
      <body>
        <div class="wrapper">
          <div class="header">
            <div class="landing-header">
              <div class="header-logos-grid">
                <div class="logo-cell left">
                  <img
                    src="/images/logo-prefeitura.png"
                    alt="Prefeitura de José de Freitas"
                    class="header-logo"
                  />
                </div>
                <div class="logo-cell center">
                  <img
                    src="/images/logo-mcmv.png"
                    alt="Programa MCMV"
                    class="header-logo"
                  />
                </div>
                <div class="logo-cell right">
                  <img
                    src="/images/logo-secretaria.jpg"
                    alt="Secretaria Municipal de Assistência Social e Cidadania"
                    class="header-logo"
                  />
                </div>
              </div>
            </div>
             
            <div class="badge">Nº ${numero_inscricao}</div>
          </div>
<p style="text-align: center; font-size: 18px; font-weight: 600;">Comprovante de inscrição</p>
          <div class="title"><h2>Dados do(a) inscrito(a)</h2></div>

          <div class="grid">
            <div class="row"><div class="label">Nome</div><div class="value">${nome || '-'}</div></div>
            <div class="row"><div class="label">CPF</div><div class="value">${cpf || '-'}</div></div>
            <div class="row"><div class="label">Email</div><div class="value">${email || '-'}</div></div>
            <div class="row"><div class="label">Data da inscrição</div><div class="value">${createdAtDisplay}</div></div>
            <div class="row"><div class="label">Status</div><div class="value">${statusDisplay}</div></div>
          </div>

          <div class="footer">
            <small>Guarde este comprovante. Ele contém seu número de inscrição.</small>
            <div class="print-actions">
              <button class="btn" onclick="window.close()">Fechar</button>
              <button class="btn btn-primary" onclick="window.print()">Imprimir</button>
            </div>
          </div>
        </div>
      </body>
    </html>
  `;
  win.document.open();
  win.document.write(html);
  win.document.close();
}